import React from 'react';
import PropTypes from 'prop-types';
import createWidget from '../createWidget';
import { BarChartComponent } from '../../BarChartComponent_v2.js';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

/**
 * BarChartInner - Inner component for the bar chart widget
 * Renders the actual bar chart visualization
 */
const BarChartInner = ({ data, config }) => {
  // Handle date grouping changes
  const handleDateGroupingChange = (newGrouping) => {
    console.log('Date grouping changed:', newGrouping);
  };

  return (
    <BarChartComponent
      data={data.data}
      title={config.title}
      valueName={config.valueName}
      dateFormat={config.dateFormat}
      legendPosition={config.legendPosition}
      dateGrouping={config.dateGrouping}
      setDateGrouping={handleDateGroupingChange}
      showButtons={config.showButtons}
      orientation={config.orientation}
    />
  );
};

BarChartInner.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.array
  }).isRequired,
  config: PropTypes.shape({
    title: PropTypes.string.isRequired,
    valueName: PropTypes.string,
    dateFormat: PropTypes.string,
    showButtons: PropTypes.bool,
    legendPosition: PropTypes.oneOf(['bottom', 'right', 'top', 'left']),
    orientation: PropTypes.oneOf(['vertical', 'horizontal']),
    dateGrouping: PropTypes.object
  }).isRequired
};

/**
 * BarChartWidget - Created using the widget factory
 * Displays data as a bar chart
 */
const BarChartWidget = createWidget('barchart', BarChartInner, {
  includeDates: true,
  emptyState: {
    title: 'No chart data available',
    description: 'Try adjusting your filters or date range',
    icon: icon({ name: 'chart-bar', family: 'sharp', style: 'light' })
  }
});

export default BarChartWidget;
